import React, { Component } from 'react';
import { Form, Validators } from '../../../components/form/DynamicFormTs';
import Http from '../../../Http';
import { DynamicForm } from '../../../components/form/DynamicForm';
import { Button, TextField, Snackbar, Slide } from '@material-ui/core';
import BuscarGuia from '../../../components/BuscarGuia';
import { DialogComponent } from '../../../components/dialog/DialogComponent';
import { objectAsParams } from '../../../helpers';
import { AuthContext } from '../../../context/authContext';
import ACCESS from '../../../ACCESS';

function GuiaObj(id_guia, id_entrega, linea, guia = {}, cliente = {}) {
  return { id_guia, id_entrega, linea, guia, cliente }
}

const GuiaEntrega = ({ linea, folio, rsocial, origen_sucursal, destino_sucursal, tipo_entrega, onChange, onDelete, disabledDelete }) => {
  return (
    <div className='row'>
      <div className='col-sm-1'>
        <TextField
          fullWidth
          disabled
          onChange={(e) => onChange('linea', e.target.value)}
          value={linea}
          label='Línea'
        />
      </div>
      <div className='col-sm-1'>
        <TextField
          fullWidth
          disabled
          value={folio}
          label='Guía'
        />
      </div>
      <div className='col-sm-2'>
        <TextField
          fullWidth
          disabled
          value={rsocial}
          label='Cliente'
        />
      </div>
      <div className='col-sm-2'>
        <TextField
          fullWidth
          disabled
          value={origen_sucursal}
          label='Origen'
        />
      </div>
      <div className='col-sm-2'>
        <TextField
          fullWidth
          disabled
          value={destino_sucursal}
          label='Destino'
        />
      </div>
      <div className='col-sm-2'>
        <TextField
          fullWidth
          disabled
          value={tipo_entrega}
          label='Entrega'
        />
      </div>
      <div className='col-sm-2'>
        {!disabledDelete &&
          <Button variant='outlined' color='primary' fullWidth onClick={onDelete}>Eliminar</Button>
        }
      </div>
    </div>
  )
}
class Entrega extends Component {

  state = {
    guias: [],
    FormData: new Form([
      Form.Space(8),
      Form.Field('text', 'id', 'Entrega (folio)', '', [], 4, [], [], [], false, true),
      Form.Field('date-hour', 'fecha', 'Fecha', new Date(), [Validators.required], 12, [], [], [], false, true),
      Form.Section("Chofer"),
      Form.Field("hidden", "id_unidad_transporte", "", "", [Validators.required], 0),
      Form.Field("autocomplete","operador_nombre","Buscar Chofer","",[Validators.required],6),
      Form.Field("select", "id_transportista", "Transportista", "", [Validators.required], 6, [], [], [], false, true),
      Form.Field("text", "chofer_numero_licencia", "Licencia Chofer", "", [Validators.required, Validators.maxLength(16), Validators.minLength(6) ], 6),
      Form.Field("text","chofer_rfc","RFC Chofer","",[Validators.required, Validators.rfc_fisica],6),
      Form.Field("number","chofer_codigo_postal","Codigo Postal","",[Validators.required],6),
      Form.Field("select","chofer_id_colonia","Colonia","",[Validators.required],6),
      Form.Field("text","chofer_calle","Calle","",[Validators.required],6),
      Form.Field("text","chofer_numero","Numero Exterior","",[Validators.required],6),
      Form.Section("Camion"),
      Form.Field("hidden", "id_camion", "", "", [Validators.required], 0),
      Form.Field("autocomplete","camion","Clave camion","",[Validators.required], 6),
      Form.Field("select","id_permiso_sct","Persmiso SCT","",[Validators.required], 6),
      Form.Field("text","camion_permiso_sct","Numero Persmiso SCT","",[Validators.required], 6),
      Form.Field("text","camion_poliza_seguro","Póliza Seguro","",[Validators.required], 6),
      Form.Field("text","camion_aseguradora","Nombre Aseguradora","",[Validators.required],6),
      Form.Field("text","camion_placas","Placas Camión","",[Validators.required],6),
      Form.Field("number","camion_modelo","Modelo Camión","",[Validators.required],6),
      Form.Field("select","id_configuracion_vehicular","Config Vehicular","",[Validators.required],6),
      Form.Field("select","PesoBrutoVehicular","Peso Bruto Vehicular(toneladas)","",[Validators.required],6),
    ], [], 'Asignación de entrega'),
    sbOpen: false,
    sbMsg: '',
    dgOpen: false,
    dcfOpen: false,
    dcfFolio: '',
    tipo_entrega: '',
    mode: 'typing'
  };
  idUnidadTransporte = false;

  FormConfig = (config, data, formFill = null) => {
    this.FillForm(data);
    this.config = config;
    this.setState({ FormData: data })
    // console.log(data)
  }

  async componentDidMount() {
    this.initial = true;
    if (this.props.id) {
      await this.LoadPreds(this.props.id)
    }
    this.FillForm(this.state.FormData);
  }

  FillForm = async (FormData) => {
    const params = {};
    let newForm = FormData;

    if (this.initial) {
      params["initial"] = true;
    }
    if (this.choferChangeAuto) {
      params["chofer"] = this.choferChangeAuto;
      this.choferChangeAuto = null;
    }
    if (this.choferId) {
      params["choferid"] = this.choferId;
      this.choferId = null;
    }
    if (this.formCp) {
      params["chofercp"] = this.formCp;
      this.formCp = null;
    }
    if (this.camionChangeAuto) {
      params["camion"] = this.camionChangeAuto;
      this.camionChangeAuto = null;
    }
    if (this.camionId) {
      params["camionid"] = this.camionId;
      this.camionId = null;
    }

    const Res = await Http.get(
      `preguia/asigancion/form?${objectAsParams(params)}`
    );

    if (!Res.error) {
      const { choferes, choferes_colonias, configAutotransportes, transportistas, camiones, tipos_permiso } = Res.data;
      if (choferes) {
        newForm = Form.FieldOptions(
          newForm,
          "operador_nombre",
          choferes,
          "id",
          "chofer_nombre"
        );
      }
      if (choferes_colonias) {
        newForm = Form.FieldOptions(
          newForm,
          "chofer_id_colonia",
          choferes_colonias,
          "id",
          "colonia"
        );
      }
      if (configAutotransportes) {
        newForm = Form.FieldOptions(
          newForm,
          "id_configuracion_vehicular",
          configAutotransportes,
          "id",
          "descripcion"
        );
      }
      if (transportistas) {
        newForm = Form.FieldOptions(
          newForm,
          "id_transportista",
          transportistas,
          "id",
          "transportista_nombre"
        );
      }
      if (camiones) {
        newForm = Form.FieldOptions(
          newForm,
          "camion",
          camiones,
          "id",
          "camion"
        );
      }
      if (tipos_permiso) {
        newForm = Form.FieldOptions(
          newForm,
          "id_permiso_sct",
          tipos_permiso,
          "id",
          "descripcion"
        );
      }
    }

    if (this.initial) {
      newForm = Form.ValueChange(newForm, {
        operador_nombre: this.choferChange,
        camion: this.camionChange,
        chofer_codigo_postal: this.choferCodigoPoatalChange,
      });
      this.initial = false;
    }

    return newForm;
  }

  /* choferTiming = null;
  choferChange = (field) => {
    // console.log(field.ValueAt)
    clearTimeout(this.choferTiming);
    this.choferTiming = setTimeout(() => {
      this.FillForm(field.ValueAt);
    }, 600);
  } */

  LoadPreds = async (predId = null) => {
    const { hasAccess } = this.context;
    let id = predId ? predId : this.props.match.params.id;
    let Res = await Http.get(`entrega/one/${id}`);
    if (!Res.error) {
      const guias = Res.data.guias.map(guia => GuiaObj(guia.id, null, guia.linea, guia));
      let formData = this.state.FormData;
      formData = Form.Patch(formData, Res.data, true)
      if (!(hasAccess(ACCESS.ASIGNACION_TRANSPORTISTA.EDITAR_SIN_RESTRICCIONES))) {
        formData = Form.FieldMod(formData, 'id_unidad_transporte', 'Disabled', true);
        formData = Form.FieldMod(formData, 'operador_nombre', 'Disabled', true);
        formData = Form.FieldMod(formData, 'id_transportista', 'Disabled', true);
        formData = Form.FieldMod(formData, 'chofer_numero_licencia', 'Disabled', true);
        formData = Form.FieldMod(formData, 'chofer_rfc', 'Disabled', true);
        formData = Form.FieldMod(formData, 'chofer_codigo_postal', 'Disabled', true);
        formData = Form.FieldMod(formData, 'chofer_id_colonia', 'Disabled', true);
        formData = Form.FieldMod(formData, 'chofer_calle', 'Disabled', true);
        formData = Form.FieldMod(formData, 'chofer_numero', 'Disabled', true);
        formData = Form.FieldMod(formData, 'id_camion', 'Disabled', true);
        formData = Form.FieldMod(formData, 'camion', 'Disabled', true);
        formData = Form.FieldMod(formData, 'id_permiso_sct', 'Disabled', true);
        formData = Form.FieldMod(formData, 'camion_permiso_sct', 'Disabled', true);
        formData = Form.FieldMod(formData, 'camion_poliza_seguro', 'Disabled', true);
        formData = Form.FieldMod(formData, 'camion_aseguradora', 'Disabled', true);
        formData = Form.FieldMod(formData, 'camion_placas', 'Disabled', true);
        formData = Form.FieldMod(formData, 'camion_modelo', 'Disabled', true);
        formData = Form.FieldMod(formData, 'id_configuracion_vehicular', 'Disabled', true);
      }
      if (Res.data.id_camion) {
        this.camionChange({ Value: Res.data.id_camion });
      }
      if (Res.data.id_unidad_transporte) {
        this.choferChange({ Value: Res.data.id_unidad_transporte });
      }
      this.setState({ FormData: formData, guias })
    }
  }

  onSubmit = async (i, vals) => {

  }
  formChange = (form, field) => { this.setState({ FormData: Form.Change(form, field) }) }

  guardar = async () => {
    const { guias, tipo_entrega } = this.state;
    this.setState({ loading: true })
    let Vals = Form.FieldsValues(this.state.FormData);
    if (guias.length === 0)
      return this.setState({ sbMsg: 'No hay guías', sbOpen: true, loading: false });
    try {
      let Res = await Http.post(`entrega/save`, {
        entrega: { ...Vals, tipo_entrega },
        guias,
      });
      if (!Res.error) {
        this.setState({ sbMsg: 'Guardado', sbOpen: true, dcfFolio: Res.data.Folio, dcfOpen: true, loading: false });
        return;
      }
      else {
        this.setState({ sbMsg: Res.errMsg, sbOpen: true, loading: false });
      }
    } catch (error) {

    }
  }

  onFolio = () => {
    this.setState({ dcfOpen: false });
    this.props.onSave();
  }

  agregarGuia = () => {
    this.setState({ dgOpen: true })
  }

  choferChange = async (field) => {
    if (field.Value && !isNaN(field.Value)) {
      let Res = await Http.get(`unidad-transporte/one/${field.Value}`);
      if (!Res.error) {
        let formData = this.state.FormData;
        const {
          id,
          chofer_calle,
          chofer_rfc,
          chofer_numero_licencia,
          chofer_numero,
          chofer_id_colonia,
          codigo_postal,
          id_transportista,
        } = Res.data;
        this.choferId = id;
        formData = await this.FillForm(formData);

        this.setState({
          FormData: Form.Patch(
            formData,
            {
              id_unidad_transporte: id,
              operador_nombre: id + "",
              chofer_calle,
              chofer_rfc,
              chofer_numero_licencia,
              chofer_numero,
              chofer_id_colonia,
              chofer_codigo_postal: codigo_postal,
              id_transportista,
            },
            false
          ),
        });
      }
    } else {
      this.choferChangeAuto = field.ValueAt;
      this.setState({
        FormData: await this.FillForm(this.state.FormData),
      });
    }
  };

  camionChange = async (field) => {
    if (field.Value && !isNaN(field.Value)) {
      let Res = await Http.get(`camion/one/${field.Value}`);
      if (!Res.error) {
        let formData = this.state.FormData;
        const {
          id,
          camion_placas,
          camion_modelo,
          camion_aseguradora,
          camion_poliza_seguro,
          camion_permiso_sct,
          id_permiso_sct,
          id_configuracion_vehicular,
          PesoBrutoVehicular,
        } = Res.data;
        formData = await this.FillForm(formData);

        this.setState({
          FormData: Form.Patch(formData, {
            id_camion: id,
            camion_placas,
            camion_modelo,
            camion_aseguradora,
            camion_poliza_seguro,
            camion_permiso_sct,
            id_permiso_sct,
            id_configuracion_vehicular,
            PesoBrutoVehicular,
          }),
        });
      }
    } else {
      this.camionChangeAuto = field.ValueAt;
      this.setState({
        FormData: await this.FillForm(this.state.FormData),
      });
    }
  };

  choferCodigoPoatalChange = async (field) => {
    if (field.Value.length === 5) {
      this.formCp = field.Value;
      this.setState({ FormData: await this.FillForm(this.state.FormData) });
    }
  };

  seleccionadaGuia = (guia) => {
    this.setState((state) => {
      if (state.guias.some(sguia => sguia.id_guia === guia.id)) {
        state.sbOpen = true;
        state.sbMsg = 'La guia ya fue seleccionada';
      } else {
        if (state.tipo_entrega === '') {
          state.tipo_entrega = guia.tipo_entrega;
        }
        if (state.tipo_entrega !== guia.tipo_entrega) {
          state.sbOpen = true;
          state.sbMsg = 'Verifica el tipo de entrega';
          return state
        }
        state.guias.push(GuiaObj(guia.id, null, state.guias.length + 1, guia))
        state.dgOpen = false;
      }
      return state;
    })
  }

  modificarGuia = (gi, prop, value) => {
    this.setState((state) => {
      state.guias[gi][prop] = value;
      return state;
    })
  }

  elimianarGuia = (gi) => {
    this.setState((state) => {
      state.guias[gi].deleted = true;
      if (state.guias.every(guia => guia.deleted)) {
        state.tipo_entrega = '';
      }
      return state;
    })
  }

  changeMode = () => {
    this.setState({
      mode: this.state.mode === 'typing' ? 'scanning' : 'typing'
    });
  }

  render() {
    const {
      guias,
      FormData,
      sbMsg,
      sbOpen,
      dcfFolio,
      dcfOpen,
      loading = false,
      mode,
    } = this.state;
    const { hasAccess } = this.context;
    return (
      <div>
        <DynamicForm form={FormData} formChange={this.formChange} onSubmit={this.onSubmit} />

        <div>
          {!this.props.id && hasAccess(ACCESS.ASIGNACION_TRANSPORTISTA.AGREGAR_GUIAS_A_ASIGNACION) && (
          <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
            <BuscarGuia onSelect={this.seleccionadaGuia} estado={[23]} mode={mode} condiciones/>
          </div>)
          }

          <div style={{ marginTop: 10, marginBottom: 10 }}>
            {
              guias.map((guia, gi) => (!guia.deleted &&
                <GuiaEntrega
                  key={gi}
                  linea={guia.linea}
                  folio={guia.guia.g_folio}
                  rsocial={guia.guia.cliente_rsocial}
                  origen_sucursal={guia.guia.origen_sucursal}
                  destino_sucursal={guia.guia.destino_sucursal}
                  tipo_entrega={guia.guia.tipo_entrega}
                  disabledDelete={this.props.id}
                  onChange={(prop, val) => this.modificarGuia(gi, prop, val)}
                  onDelete={() => this.elimianarGuia(gi)}
                />
              ))
            }
          </div>

          <div style={{ textAlign: 'right' }}>
            <Button variant='outlined' onClick={this.onFolio}>Cerrar</Button>
            {(!this.props.id || hasAccess(ACCESS.ASIGNACION_TRANSPORTISTA.EDITAR_SIN_RESTRICCIONES)) &&
              <Button variant='contained' color='primary' onClick={this.guardar} disabled={FormData.Invalid || loading}>Guardar</Button>
            }
          </div>
        </div>

        <DialogComponent
          open={dcfOpen}
          title='Folio de transportista'
          onClose={() => this.onFolio()}
          options={['Aceptar']}
        >
          <p style={{ textAlign: 'center', fontWeight: 'bolder', fontSize: 30, margin: 0, lineHeight: '0.8' }}>#{dcfFolio}</p>
        </DialogComponent>

        <div>
          <Snackbar
            open={sbOpen}
            onClose={() => { this.setState({ sbOpen: false }) }}
            TransitionComponent={Slide}
            message={<span>{sbMsg}</span>}
          />
        </div>

      </div>
    )
  }
}
Entrega.contextType = AuthContext
export default Entrega;